// import {FetchSingleResource} from '../../../viscomjs/load/FetchSingleResource';
import {FetchResourcesFunction} from '../../../../../viscomjs/load/FetchResources';
import {WebFontLoad} from '../../../../../viscomjs/load/WebFontLoad';
import {FuncCallPromise} from '../../utils/FuncCallPromise';
import {PrepareTexturesFunction} from './PrepareTextures';
import {LoadImagesFunction} from '../load/LoadImages';
import {LoadStoryFunction} from '../load/LoadStory';
import {LoadObjectSetFunction} from '../../../../../viscomjs/threejs/load/LoadObjectSet';
import {fonts} from '../../../settings/fonts';
import {initialDataManifest, initialImagesManifest, initialStories, geometriesManifest, maxTexturesType} from '../../../settings/resources';
import {StoriesMap} from '../../../../stories/ImportStoriesToBuild';
import {prepareManifest} from '../../../helpers/prepareManifest';
import {PreloaderDisplay} from '../../../components/preloader/PreloaderDisplay';
const Preloader = new PreloaderDisplay();

const _displayProgress = p => {
    Preloader.init(document.querySelector('.preloader'), document.querySelector('.preloader__bar'));
    Preloader.update(p);
    if (+p >= 0.98) Preloader.destroy(p);
    return p;
};

const __progress = (from, to) => {
    return (p = 0) => {
        return _displayProgress(from + (to - from) * p);
    };
};

const __callProgress = (from, to, value) => {
    return doThat => {
        return FuncCallPromise(__progress(from, to), doThat, [value]);
    };
};

const LoadApp = doThat => {
    //
    //
    //     1. Load fonts:
    let promise = WebFontLoad(fonts, doThat)
        .then(__callProgress(0, 0.01, 1))

        //
        // 2. Load data:
        //
        // - rss: json-format / text or images manifest
        // - textures preparation settings
        // - textures configurations
        // - camera configurations and animation or animation settings

        // TODO: make critical set of urls and display an error message
        .then(FetchResourcesFunction(prepareManifest(initialDataManifest), false, __progress(0.01, 0.1)))

        //
        // 3. Prepare 3d Stage:
        //
        // 3.1. Prepare initial set of textures: render or download
        .then(PrepareTexturesFunction(maxTexturesType, __progress(0.1, 0.35)))
        .then(LoadImagesFunction(initialImagesManifest, __progress(0.35, 0.4)))
        //
        // 3.2. Load Geometries
        .then(LoadObjectSetFunction(prepareManifest(geometriesManifest), false, __progress(0.4, 0.49)))

        .then(__callProgress(0, 0.5, 1));

    // TODO: from model:
    const stories = initialStories;
    const l = stories.length;
    let i;

    // 4. Prepare initial stories animations:
    for (i = 0; i < l; i++) {
        //
        //     4.1. Load stories packs:
        promise = promise.then(LoadStoryFunction(StoriesMap[stories[i]], __progress(0.5 + (0.5 * i) / l, 0.5 + (0.5 * (i + 1)) / l)));
    }

    promise = promise.then(__callProgress(0, 1, 1));

    return promise;
};

export {LoadApp};
